import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const translations = {
	en: {
		translation: {}, // Define your translations here or fetch them from somewhere else
	},
};

i18n.use(initReactI18next).init({
	lng: 'en',
	fallbackLng: 'en',
	debug: true,
	resources: translations,
	interpolation: {
		escapeValue: false, // not needed for react as it escapes by default
	},
});

export const addTranslations = (
	language: string,
	namespace: string,
	translations: Record<string, string>
) => {
	i18n.addResourceBundle(language, namespace, translations, true, false);
};

export default i18n;
